import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bina-code-item',
  templateUrl: './bina-code-item.component.html',
  styleUrls: ['./bina-code-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BinaCodeItemComponent implements OnInit {
  @Input() public groupNumber: string;
  @Input() public showDot: boolean = true;
  @Input() public capsulePlaceholderCount: number = 2;
  @Input() public isInvalid: boolean = false;

  public capsulePlaceholdersArr: any[];

  ngOnInit(): void {
    this.capsulePlaceholdersArr = new Array(this.capsulePlaceholderCount);
  }
}
